/** Assemble des noms de classes en ignorant les valeurs vides. */
export function classes(...noms: (string | false | null | undefined)[]): string {
  return noms.filter(Boolean).join(' ');
}

/** Lecture tolérante du stockage local (navigation privée, stockage bloqué). */
export function lireStockage<T>(cle: string): T | null {
  try {
    const brut = window.localStorage.getItem(cle);
    return brut === null ? null : (JSON.parse(brut) as T);
  } catch {
    return null;
  }
}

export function ecrireStockage(cle: string, valeur: unknown): boolean {
  try {
    window.localStorage.setItem(cle, JSON.stringify(valeur));
    return true;
  } catch {
    return false;
  }
}

export function effacerStockage(cle: string): void {
  try {
    window.localStorage.removeItem(cle);
  } catch {
    // Stockage indisponible : rien à effacer.
  }
}

/** Heure locale au format 10:42. */
export function heureCourte(date: Date): string {
  return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}
